import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const CreditTerms = () => {
  return (
    <Container>
      <TermsTitle>신용정보활용체제</TermsTitle>
      <TermsSubject>
        (주)브릿지인베스트먼트(이하 ‘회사’)는 정보주체의 개인정보 및 신용정보 보호를 중요시하며, 「신용정보의 이용 및
        보호에 관한 법률」 제31조에 의거, 회사가 수집, 관리하고 있는 신용정 보의 활용체제에 대하여 다음과 같이
        공개합니다.
      </TermsSubject>
      <TermsListWrap>
        <TermsTit>제 1 조 (관리, 수집하는 신용정보의 종류 및 이용목적)</TermsTit>
        <ul>
          <li>① 관리, 수집하는 신용정보의 종류</li>
          <li>
            <ul className="ul-indent">
              <li>
                1. 식별정보: 개인의 성명, 주민등록번호(외국인등록번호, 국내거소신고번호 등 포함), 여권번 호,
                운전면허번호, 성별, 국적, 주소, 연락처, 직장정보, 개인사업자 및 법인의 상호, 사업자 ⦁ 법인등록번호,
                대표자 성명, 소재지 등
              </li>
              <li>
                2. 거래정보: 본 거래 이전 및 이후의 대출, 보증, 담보제공, 신용카드, 할부금융 등 상거래 관련 거래의 종류,
                기간, 금액 및 한도 등
              </li>
              <li>3. 신용도판단 정보 (연체, 부도, 대위변제, 기타 신용질서 문란행위 관련 금액, 발생·해소 시 기 등)</li>
              <li>4. 신용거래 능력정보 (재산, 채무, 소득의 총액, 납세실적 등)</li>
              <li>
                5. 기타 공공기관 보유정보 (개인회생, 파산, 면책, 채무불이행자 등재 등 법원의 재판·결정 정 보, 체납정보,
                주민등록 관련정보, 사회보험·공공요금 관련정보 등)
              </li>
              <li>6. 기타 본인의 신용을 판단할 수 있는 정보 (신용등급, 신용조회, 채무재조정약정 등)</li>
              <li>7. 본 계약 이전 및 이후의 대출 세부내역, 관련인 정보, 자체기준에 따라 책정한 신용도평가 내용 등</li>
              <li>8. 본인이 대표자로 있는 가맹점의 기업정보(사업자번호, 상호, 업종코드 등), 매출정보 등</li>
              <li>9. 기타 관련하여 본인이 제공한 정보</li>
            </ul>
          </li>

          <li>② 이용목적</li>
          <li>
            <ul className="ul-indent">
              <li>
                1. (금융)거래관계의 설정, 유지, 이행, 관리(통계, 모형개발 등 포함), 서비스 제공, 법령상 의 무이행,
                신용질서 문란행위 조사, 분쟁처리, 민원처리, 본인여부 확인 등
              </li>
              <li>2. 기타 동법 및 관련 법률의 규정에서 정한 경우</li>
            </ul>
          </li>
        </ul>
      </TermsListWrap>

      <TermsListWrap>
        <TermsTit>제 2 조 (신용정보의 보유 및 이용기간)</TermsTit>
        <p>
          회사는 원칙적으로 정보주체와의 금융거래 종료일로부터 5년까지 정보주체의 신용정보를 보 유, 이용합니다. 단,
          금융거래 종료일 이후에는 사전에 동의를 받은 경우, 「신용정보법」, 상법 등 관련법규에 의하여 보존할 필요성이
          있는 경우 또는 금융사고 조사, 분쟁해결, 민원처리, 기타 법령상 의무이행을 위해서만 신용정보를 보유, 이용합니다.
        </p>
      </TermsListWrap>

      <TermsListWrap>
        <TermsTit>제 3 조 (신용정보의 파기 절차 및 방법)</TermsTit>
        <ul>
          <li>
            ① 회사는 신용정보 보유기간의 경과, 처리목적 달성 등 신용정보가 불필요하게 되었을 때에 는 지체 없이 해당
            신용정보를 파기합니다.
          </li>
          <li>
            ② 정보주체로부터 동의 받은 신용정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불 구하고 다른 법령에
            따라 신용정보를 계속 존속하여야 하는 경우에는 해당 신용정보를 별 도의 데이터베이스(DB)로 옮기거나 보관장소를
            달리하여 보존합니다.
          </li>
          <li>③ 신용정보 파기의 절차 및 방법은 다음과 같습니다.</li>
          <li>
            <ul className="ul-indent">
              <li>
                1. 파기절차
                <ul className="ul-indent">
                  <li>
                    가. 금융거래 등을 위해 제공된 정보는 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의 한 정보보호
                    사유에 따라(보유 및 이용기간 참조)일정 기간 저장된 후 파기됩니다.
                  </li>
                  <li>
                    나. 동 신용정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.
                  </li>
                </ul>
              </li>
              <li>
                2. 파기방법
                <ul className="ul-indent">
                  <li>가. 종이에 출력된 신용정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다. </li>
                  <li>
                    나. 전자적 파일 형태로 저장된 신용정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </TermsListWrap>

      <TermsListWrap>
        <TermsTit>제 4 조 (신용정보의 제3자 제공 등)</TermsTit>
        <ul>
          <li>
            ① 회사는 정보주체의 동의가 있거나, 관련법령의 규정에 의한 경우를 제외하고는 어떠한 경 우에도 본 처리방침
            상의 신용정보의 수집항목 및 이용목적에서 고지한 범위를 넘어 정보 주체의 신용정보를 이용하거나 제3자에게
            제공하지 않습니다.
          </li>
          <li>
            ② 정보주체의 신용정보를 제공하거나 공유하는 경우에는 사전에 귀하에게 제공하는 신용정보 의 종류, 제공 대상,
            제공받는 자의 이용목적 등에 대해 개별적으로 전자우편 또는 서면을 통해 고지한 후 이에 대한 동의를 구합니다.
            다만, 다음 각호의 경우에는 예외로 합니다.
          </li>
          <li>
            <ul className="ul-indent">
              <li>1. 정보주체가 사전에 동의한 경우</li>
              <li>
                2. 「금융실명거래 및 비밀보장에 관한 법률」, 「신용정보의 이용 및 보호에 관한 법률」, 「금융
                지주회사법」, 「전기통신기본법」, 「전기통신사업법」, 「지방세법」, 「소비자보호법」, 「한국은 행법」,
                「형사소송법」 등 법령의 규정에 의거하여 제출을 요구하는 공공기관 및 신용정보원 등 제공 가능한 기관
              </li>
              <li>3. 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
              <li>
                4. 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 가공하여
                제공하는 경우
              </li>
            </ul>
          </li>
        </ul>
      </TermsListWrap>

      <TermsListWrap>
        <TermsTit>제 5 조 (신용정보처리 위탁 내용 및 수탁자)</TermsTit>
        <p>
          회사는 현재 신용정보처리를 위탁하여 처리하지 않습니다. 그러나 향후 정보주체를 위한 서비 스 이행 등을 위하여
          외부 전문 업체에 신용정보의 처리를 위탁하는 경우, 신용정보보호 관련 지시 엄수, 신용정보에 관한 무단 이용 등
          금지 및 사고 시의 책임부담 등을 명확히 규정한 위탁계약을 체결하고, 수탁자 명을 본 활용체제 등을 통해
          공지하도록 하겠습니다.
        </p>
      </TermsListWrap>

      <TermsListWrap>
        <TermsTit>제 6 조 (신용정보주체의 권리와 그 행사 방법)</TermsTit>
        <ul>
          <li>
            ① 신용정보 이용 및 제공 사실의 조회
            <ul>
              <li>
                1. 신용정보주체는 회사의 사무소•점포 등에서 본인의 신분을 나타내는 증표를 내보이는 방법 으로 본인임을
                확인한 후 회사가 본인의 개인신용정보를 이용 및 제공한 사실을 조회할 수 있습니다. 신용정보주체가 조회할
                수 있는 조회사항은 조회가 의뢰된 날을 기준으로 최근 3년간의 조회사항으로 합니다.
              </li>
              <li>
                2. 제1호에 따라 조회를 한 신용정보주체는 회사가 개인신용정보를 이용하거나 제공한 때에 신용정보주체에게
                통지하도록 요청할 수 있으며, 통보요청을 받으면 회사는 해당 정보주체 에게 연1회 이상 정기적으로 서면,
                전자우편, 문자메시지, 그 밖에 이와 유사한 방법으로 금융위원회가 정하여 고시하는 서식에 따라 조회사항을
                통보합니다. 이때 통지와 관련하여 소요되는 비용은 신용정보주체가 부담할 수 있습니다.
              </li>
            </ul>
          </li>
          <li>
            ② 신용정보의 열람 및 정정 청구
            <ul>
              <li>
                1. 신용정보주체는 본인의 신분을 나타내는 증표를 내보이거나 전화, 인터넷 홈페이지의 이용 등 대통령령으로
                정하는 방법으로 본인임을 확인받아 회사가 보유하고 있는 신용정보주체 본인의 신용정보에 대한 교부 또는
                열람을 청구할 수 있습니다.
              </li>
              <li>
                2. 자신의 신용정보를 열람한 정보주체는 본인의 신용정보가 사실과 다른 경우 회사에서 정한 개인(신용)정보
                정정 요구서를 작성하여 제출하는 방식으로 개인신용정보의 정정을 청구할 수 있습니다. 이 경우 회사는
                정정청구가 정당한 사유가 있다고 인정되면 지체없이 해당 신용정보의 제공∙이용을 중단한 후 사실인지를
                조사하여 조치하고, 그 처리결과를 해당 신용정보주체에게 고지할 수 있습니다.
              </li>
            </ul>
          </li>
          <li>
            ③ 상거래 거절 근거 신용정보의 고지
            <ul>
              <li>
                1. 신용정보주체는 회사가 개인신용평가회사, 개인사업자신용평가회사, 기업신용조회회사 (기 업정보조회업무만
                하는 기업신용조회회사는 제외한다) 및 신용정보집중기관으로부터 제공 받은 개인신용정보로서 신용정보법
                시행령 제31조 제1항에 정하는 정보에 근거하여 상대 방과의 상거래관계 설정을 거절하거나 중지하였을 때 그
                거절 또는 중지의 근거가 된 신용 정보 등을 본인에게 고지할 것을 요구할 수 있습니다.
              </li>
              <li>
                2. 신용정보주체로부터 상거래 관계 설정의 거절이나 중지의 근거가 되는 신용정보의 고지 요 구가 있으면
                회사는 본인의 신분을 나타내는 증표 등에 의해 본인 여부를 확인 후 그 거절 또는 중지의 근거가 된 정보 등
                다음 각 호의 사항을 본인에게 알려 드리겠습니다.
                <ul>
                  <li>가. 상거래 관계 설정의 거절이나 중지의 근거가 된 신용정보</li>
                  <li>
                    나. 신용정보를 제공한 개인신용평가회사, 개인사업자 신용평가회사, 기업신용조회회사 및 신
                    용정보집중기관의 명칭·주소 및 전화번호 등
                  </li>
                  <li>
                    다. 개인신용평가회사, 개인사업자 신용평가회사, 기업신용조회회사 및 신용정보집중기관이 상 거래관계의
                    설정을 거절하거나 중지하도록 결정한 것이 아니라는 사실 및 개인신용평가회 사, 개인사업자
                    신용평가회사, 기업신용조회회사 또는 신용정보집중기관으로부터 제공 받 은 정보 외에 다른 정보를 함께
                    사용했을 경우 그 사실과 그 다른 정보
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            ④ 신용정보 제공•이용 동의 철회권 등
            <ul>
              <li>
                1. 신용정보주체는 개인신용평가회사, 개인사업자 신용평가회사 또는 신용정보집중기관에 제 공하여 개인의
                신용도 등을 평가하기 위한 목적 외의 목적으로 행한 개인신용정보 제공 동 의를 동의 철회의 대상 및 내용
                등을 특정하여 회사의 홈페이지, 유무선통신, 서면, 그 밖 에 회사의 사무실·점포 등을 방문하여 본인임을 확인
                후 동의철회서를 제출하는 방법 등으 로 철회할 수 있습니다. 단, 신용주체의 신용정보 제공은 회사와의
                계약체결 및 거래관계 를 위해 필수적인 부분이므로, 신용정보 제공 동의를 철회하는 경우 금융거래관계의 설정
                및 유지가 불가능함을 알려드립니다.
              </li>
              <li>
                2. 신용정보주체는 회사가 상품이나 용역을 소개하거나 구매를 권유할 목적으로 연락하는 것 에 대하여
                연락중지 청구의 대상 및 내용을 특정하여 회사의 인터넷홈페이지, 유무선통신, 서면, 그 밖에 회사의
                사무실·점포 등을 방문하여 본인에게 연락하는 것을 중지하도록 청 구할 수 있습니다.
              </li>
              <li>
                3. 회사는 제1호 및 제2호의 청구를 받은 날로부터 1개월 이내에 그에 따른 조치를 완료하고 그 결과를 해당
                개인정보주체에게 알려드립니다.
              </li>
            </ul>
          </li>
          <li>
            ⑤ 신용정보의 삭제 요구
            <ul>
              <li>
                1. 신용정보주체는 법령에서 따로 정하는 경우를 제외하고, 금융거래 등 상거래관계가 종료되 고 대통령령으로
                정하는 기간(금융거래 등 상거래관계의 설정 및 유지 등에 필수적인 개인 정보의 경우 5년, 그 외의
                개인신용정보의 경우 3개월)이 경과한 경우 개인신용정보의 삭 제를 요구할 수 있습니다.
              </li>
              <li>
                2. 회사가 신용정보주체로부터 본인의 개인신용정보의 삭제를 요구받았을 때에는 신용정보법 에서 정한 다음
                각호의 경우를 제외하고는 지체없이 해당 신용정보를 삭제하고 그 결과를 해당 신용정보주체에게
                통지하겠습니다.
                <ul>
                  <li>가. 이 법 또는 다른 법률에 따른 의무를 이행하기 위하여 불가피한 경우</li>
                  <li>나. 개인의 급박한 생명ᆞ신체ᆞ재산의 이익을 위하여 필요하다고 인정되는 경우</li>
                  <li>
                    다. 가명정보를 이용하는 경우로서 그 이용 목적, 가명처리의 기술적 특성, 정보의 속성 등을 고려하여
                    대통령령으로 정하는 기간 동안 보존하는 경우
                  </li>
                  <li>
                    라. 그 밖에 다음 각 목의 어느 하나에 해당하는 경우로서 대통령령으로 정하는 경우
                    <ul>
                      <li>1) 예금ᆞ보험금의 지급을 위한 경우</li>
                      <li>2) 보험사기자의 재가입 방지를 위한 경우</li>
                      <li>3) 개인신용정보를 처리하는 기술의 특성 등으로 개인신용정보를 보존할 필요가 있는 경우</li>
                      <li>4) 라목 1)부터 3)까지와 유사한 경우로서 개인신용정보를 보존할 필요가 있는 경우</li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            ⑥ 신용정보의 전송 요구
            <ul>
              <li>
                1. 신용정보주체는 회사가 보유하고 있는 본인에 관한 신용정보를 다음 각 호의 어느 하나에 해당하는 자에게
                전송하여 줄 것을 요구할 수 있습니다.
                <ul>
                  <li>가. 해당 신용정보주체 본인</li>
                  <li>나. 본인신용정보관리회사</li>
                  <li>다. 대통령령으로 정하는 신용정보제공ᆞ이용</li>
                  <li>라. 개인신용평가회사</li>
                  <li>마. 그 밖에 가호부터 라호까지의 규정에서 정한 자와 유사한 자로서 대통령령으로 정하는 자</li>
                </ul>
              </li>
              <li>
                2. 신용정보주체가 본인의 신용정보의 전송요구를 할 때에는 다음 각호의 사항을 모두 특정하 여 전자문서나 그
                밖에 안정성과 신뢰성이 확보된 방법으로 하여야 합니다.
                <ul>
                  <li>가. 신용정보제공ᆞ이용자 등으로서 전송요구를 받는 자</li>
                  <li>나. 전송을 요구하는 개인신용정보</li>
                  <li>다. 전송 요구에 따라 개인신용정보를 제공 받는 자</li>
                  <li>라. 정기적인 전송을 요구하는지 여부 및 요구하는 경우 그 주기 </li>
                  <li>
                    마. 그 밖에 가호부터 라호까지의 규정에서 정한 사항과 유사한 사항으로서 대통령령으로 정하는 사항
                  </li>
                </ul>
              </li>
              <li>
                3. 회사는 전송 요구를 받은 개인신용정보를 컴퓨터 처리가 가능한 방식으로 즉시 전송하여 드리겠습니다.
                다만, 최근 5년 내의 개인신용정보가 아닌 경우에는 신용정보제공ᆞ이용자 등이 정하는 방식으로 제공할 수
                있습니다.
              </li>
              <li>
                4. 신용정보주체는 서면, 「전자서명법」 제2조제2호에 따른 전자서명이 있는 전자문서, 안정성 과 신뢰성이
                확보될 수 있는 유무선 통신으로 개인비밀번호를 입력하는 방식, 그 밖에 안정 성과 신뢰성이 확보된 방법
                등으로 제1항에 따른 전송요구를 철회할 수 있습니다.
              </li>
            </ul>
          </li>
        </ul>
      </TermsListWrap>

      <TermsListWrap>
        <TermsTit>제 7 조 (신용정보관리•보호인 및 고충사항 처리부서)</TermsTit>
        <ul>
          <li>① 신용정보관리·보호인 (준법감시인)</li>
          <li>- 성 명 : 이아람</li>
          <li>- 연락처 : 070-4919-3461</li>
          <li>- 이메일 : aramlee@brdginv.com</li>
        </ul>
        <ul>
          <li>② 고충사항 처리부서</li>
          <li>- 부서명 : 관리본부</li>
          <li>- 담당업무 : 신용정보관리, 신용정보주체의 권리보호, 고객상담 및 고충처리</li>
          <li>- 연락처 : 070-4919-3470</li>
          <li>- 이메일 : abcd@brdginv.com</li>
        </ul>
      </TermsListWrap>

      <TermsListWrap>
        <TermsTit>제 8 조 (신용정보활용체제 변경 및 고지 의무 등)</TermsTit>
        <ul>
          <li>① 회사가 신용정보활용체제를 개정하는 경우, 웹사이트 공지사항을 통해 공지할 것입니다.</li>
          <li>② 본 신용정보활용체제에 별도로 명시되지 않는 사항은 개인정보처리방침의 규정을 준용합니다.</li>
          <li>③ 본 변경된 신용정보활용체제는 2022. 03. 01. 부터 적용됩니다.</li>
          <li>
            ④ 이전의 신용정보활용체제는 아래에서 확인할 수 있습니다.
            <TermsPrevListWrap>
              <Link to="/terms/credit_20220228"> - 2022년 02월 28일까지 적용분 [클릭]</Link>
            </TermsPrevListWrap>
          </li>
        </ul>
      </TermsListWrap>
    </Container>
  );
};

const Container = styled.div``;

const TermsTitle = styled.h2`
  font-size: 45px;
  font-weight: 500;
  color: #000;
  margin-bottom: 50px;
  @media (max-width: 1024px) {
    font-size: 26px;
    letter-spacing: -0.5px;
    color: #222;
    margin-bottom: 20px;
  }
`;

const TermsSubject = styled.p`
  font-size: 26px;
  line-height: 1.54;
  letter-spacing: -0.5px;
  color: #000;
  margin-bottom: 40px;
  @media (max-width: 1024px) {
    font-size: 18px;
    letter-spacing: -0.35px;
    margin-bottom: 20px;
  }
`;

const TermsListWrap = styled.div`
  &:not(:first-child) {
    margin-top: 30px;
  }
  p,
  .description {
    margin-top: 10px;
    font-size: 16px;
    line-height: 1.75;
    letter-spacing: -0.5px;
    color: #747474;
  }
  ul {
    margin: 10px 0;
    &.ul-indent {
      margin-top: 0;
      margin-left: 10px;
    }
    li {
      font-size: 16px;
      line-height: 1.75;
      letter-spacing: -0.5px;
      color: #747474;
      padding-left: 20px;
      text-indent: -20px;
      &.online-indent {
        padding-left: 36px;
      }
    }
  }
  div {
    margin-top: 10px;
    &.ul-indent {
      margin-top: 0;
      margin-left: 10px;
    }
  }
  @media (max-width: 1024px) {
    &:last-child {
      margin-top: 10px;
    }
    ul {
      margin-top: 2px;
      &.ul-indent {
        margin-left: 0;
      }
      li {
        font-size: 14px;
        line-height: 1.71;
        letter-spacing: -0.44px;
      }
    }
  }
`;

const TermsTit = styled.strong`
  display: block;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.75;
  letter-spacing: -0.5px;
  color: #333;
  border-bottom: 1px solid #ededed;
  @media (max-width: 1024px) {
    font-size: 14px;
    line-height: 2;
    letter-spacing: -0.44px;
    border-bottom: none;
  }
`;

const TermsPrevListWrap = styled.p`
  color: #747474;
  font-size: 15px;
  padding-left: 20px;
  text-indent: -20px;
  margin-top: 30px;
  a {
    color: #747474;
  }
`;

export default CreditTerms;
